// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import SubscriptionComp from '../../components/SubscriptionPage/SubscriptionPage';

const SubscriptionPage: React.FC = () => {
    return (
        <Entrypoint>
            <SubscriptionComp />
        </Entrypoint>
    );
}

export default SubscriptionPage;